import styles from '../../../utils/modal/DetailModal.module.css';

export const AuditDetailType = {
    TOKEN: 'AUDIT_TOKEN_DETAIL_MODAL',
    ADMIN: 'AUDIT_ADMIN_DETAIL_MODAL',
}

/**
 * 로그 상세 정보 모달 컨테이너
 * @param type
 * @param modalData
 * @returns {JSX.Element}
 * @constructor
 */
export const AuditDetailModal = ({type, modalData}) => {

    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>대분류</p>
                    <input className={styles.layer__listInput}
                           value={modalData.mainTypeView}
                           readOnly={true}/>
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>소분류</p>
                    <input className={styles.layer__listInput}
                           value={modalData.subTypeView}
                           readOnly={true}/>
                </li>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>로그 발생 시간</p>
                    <input className={styles.layer__listInput}
                           value={modalData.createdDateView}
                           readOnly={true}/>
                </li>


                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>사용자</p>
                    <input className={styles.layer__listInput}
                            value={modalData.unifiedProfileId}
                            readOnly={true}/>
                </li>

                {type === AuditDetailType.ADMIN ?
                    <li className={`${styles.layer__list} ${styles.Box}`}>
                        <p className={styles.layer__listTit}>로그 내용</p>
                        <textarea className={styles.layer__listInput}
                            value={modalData.detail}
                            readOnly={true}/>
                    </li>
                    : null
                }
            </ul>
        </div>
    )
}